module.exports = __webpack_public_path__ + "img/share_black_24dp.c9fbf7cb.svg";